import axios from 'axios';
import { formatResponse, formatError } from './formatResponse';
import { POSTAL_CODE_URL } from '../../constants/Constants';

const axiosConfig = {
  withCredentials: true,
};

const instanceAPI = axios.create({
  baseURL: POSTAL_CODE_URL,
  headers: { 'Content-type': 'application/json' },
  axiosConfig,
});

instanceAPI.interceptors.response.use(
  (response) => formatResponse(response),
  (error) => formatError(error),
);

export const getPostalCode = (cp) => {
  const request = instanceAPI.get(`/${cp}`);
  return request.then((res) => res).catch((error) => error);
};
